import React from "react";
import { connect } from "react-redux";
import Dialog from "@material-ui/core/Dialog";
import Axios from "axios-https-proxy-fix";
// Loading Dialog Dependencies 
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import ReactLoader from 'react-loader-spinner'
import Translated from "../../../components/Translated/Translated";
import translator from "../../../utils/translator";

function DialogEmailSpecList(props) {
	const [open, setOpen] = React.useState(false);
	const [response, setResponse] = React.useState({});
	const [loading_dialog, set_loading_dialog] = React.useState(null);

	async function handleClose() {
		setOpen(false);
	}

	async function handleClickOpen() {
		setResponse({});
		setOpen(true);
	}

	async function submit() {
		let loading_dialog =
			<Dialog open={true} aria-labelledby="form-dialog-title"><DialogTitle id="form-dialog-title set-price-dialog-header">
				{translator("Misc", "sending_label")}{" "}
			</DialogTitle>
				<DialogContent style={{ paddingRight: "10em" }}>
					<ReactLoader
						style={{ marginLeft: "8em" }}
						type="Oval"
						color="#00BFFF"
						height={50}
						width={50}
					/>
				</DialogContent>
			</Dialog>
		set_loading_dialog(loading_dialog);

		let requestURL = props.APIUrl + "/emco_quotes/email-spec-list";
		let data = {
			trendId: localStorage.getItem("trendId"),
			token: localStorage.getItem("token"),
			language: props.language,
			project_id: props.projectId
		};
		let APIResponse = await Axios.post(requestURL, data);
		setResponse(APIResponse.data);

		set_loading_dialog(null);
	}

	function formBody() {
		return (
			<div class="quote-dialog-body">
				<div class="fquote-dialog-info">
					<div><Translated section="Misc" label="send_email_spec_list_dialog_message" /></div>
				</div>
			</div>
		);
	}

	function responseBody() {
		let class_names = "quote-dialog-body quote-dialog-";
		class_names += response.hasOwnProperty("error") ? "error" : "success";

		return (
			<div className={class_names}>
				<div>{response.hasOwnProperty("error") ? response.error : response.success}</div>
			</div>
		);
	}

	let hasResponse = Object.keys(response).length;

	return (
		<div class="quote-nav-component">
			<button onClick={handleClickOpen} class="quote-nav-top-link">
				<div></div>
				<div><Translated section="Quote" label="sub_nav_spec_list" /></div>
			</button>
			<Dialog open={open} onClose={handleClose}>
				{loading_dialog}
				<div class="quote-dialog">
					<div class="quote-dialog-title"><Translated section="Misc" label="send_email_dialog_title" /></div>

					{hasResponse ? responseBody() : formBody()}

					<div class="quote-dialog-footer">
						<button class="quote-dialog-button" onClick={handleClose}>
							{hasResponse 
								? <Translated section="Misc" label="close_btn" />
								: <Translated section="Misc" label="no_btn" />
							}
						</button>
						{hasResponse ? (
							""
						) : (
							<button class="quote-dialog-button" onClick={submit}>
								<Translated section="Misc" label="yes_btn" />
							</button>
						)}
					</div>
				</div>
			</Dialog>
		</div>
	);
}

const mapStateToProps = state => ({
	APIUrl: state.APIUrl,
	projectId: state.projectIdUsedToIncreaseProductQuantity
});

const mapDispatchToProps = {};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(DialogEmailSpecList);
